<template>
    <div class="masterdata-right">
      <div class="masterdata-table">
        <table class="table-db table-db-hover">
          <thead>
          <tr>
            <!-- <th v-if="isEdit" class="editRow"></th> -->
            <th @click="sort('nomor')">Nomor <i :class="currentSort === 'nomor' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('badan_usaha')">Badan Usaha <i :class="currentSort === 'badan_usaha' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            
            <th @click="sort('nama_perusahaan')">Nama Perusahaan <i :class="currentSort === 'nama_perusahaan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>

            <th @click="sort('last_modified_date')">Last Modified Date <i :class="currentSort === 'last_modified_date' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('last_modified_by')">Last Modified By <i :class="currentSort === 'last_modified_by' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('status')">Status <i :class="currentSort === 'status' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('catatan')">Catatan <i :class="currentSort === 'catatan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <!-- <td v-if="isEdit" class="editRow" @click="editRow(list)" ><span class="fa fa-edit pointer ml20"></span></td> -->
            <td>{{list.nomor}}</td>
            <td>{{list.badan_usaha}}</td>
            <td>{{list.nama_perusahaan}}</td>
            <td>{{list.last_modified_date}}</td>
            <td>{{list.last_modified_by}}</td>
            <td :style="{color: list.status === 'Active' ? 'green' : 'red'}">{{ list.status }}</td>
            <td>{{list.catatan }}</td>
          </tr>
        </tbody>
        </table>
      </div>
      <!-- <KBLI v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll"/> -->
    </div>
    </template>
    
    <script>
      export default {
        components: {
        //   KBLI: () => import('@/views/MasterData/Edit/LegalDoc/DKBLI.vue')
        },
    
        props:{
          'isEdit' : Boolean,
        },
        data() {
          return {
            currentSort: '',
            currentSortDir: '',
            arrow : false,
            showModalEdit:false,
            editData: {
                "nomor": "",
                "badan_usaha": "",
                "nama_perusahaan": "",
                "last_modified_date": "",
                "last_modified_by": "",
                "status": "",
                "catatan": ""
            },
            data: [
                    {
                        "nomor": "1",
                        "badan_usaha": "PT",
                        "nama_perusahaan": "Golden Energy Mines",
                        "last_modified_date": "-",
                        "last_modified_by": "System",
                        "status": "Active",
                        "catatan": "Test 1"
                    },
                    {
                        "nomor": "2",
                        "badan_usaha": "PT",
                        "nama_perusahaan": "Borneo Indobara",
                        "last_modified_date": "-",
                        "last_modified_by": "System",
                        "status": "Active",
                        "catatan": "Test 2"
                    },
                    {
                        "nomor": "1",
                        "badan_usaha": "PT",
                        "nama_perusahaan": "Kuansing Inti Makmur",
                        "last_modified_date": "-",
                        "last_modified_by": "System",
                        "status": "Active",
                        "catatan": "Test 3"
                    },
                ]
          }
        },
    
      methods:{
        sort(s) {
        if(s === this.currentSort) {
          this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
        }
        this.currentSort = s;
      },
      editRow(data) {
        this.editData={
          "nomor": data.nomor,
          "deskripsi": data.deskripsi,
          "last_modified_date": data.last_modified_date,
          "last_modified_by": data.last_modified_by,
          "status": data.status,
          "catatan": data.catatan,
        }
        this.showModalEdit = true;
      },
      closeModal(){
        this.showModalEdit = false;
      },
    },
    
    computed:{
      sortedData() {
        return this.data.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    },
    
      }
    </script>